import Badge from "@/components/common/Badge";
import { formatDateLocalized, formatNumber } from "@/modules/auth/utils/format";
import { getUserDailyRatePercent } from "@/modules/auth/utils/rate";
import { constants } from "@/modules/calculations/consts";
import { DepositsItem } from "@/modules/user/types/wallet";
import { useTranslation } from "react-i18next";

const Transaction = (deposit: DepositsItem) => {
  const { t, i18n } = useTranslation();

  const depositAmount = deposit.deposit.tokenAmount;
  const status = deposit.deposit.status;
  const day = deposit.reward.targetDateTotal.day;
  const days = deposit.reward.endDate.day;
  const totalRewards = deposit.reward.endDate.amount;
  const withdrawn = deposit.reward.withdrawnTokenAmount;
  const dailyRate = getUserDailyRatePercent(day);
  const startDate = deposit.deposit.createdAt;
  const endDate = deposit.reward.endDate.date;
  const usdAmount = deposit.deposit.usdAmount;

  return (
    <>
      <div className="w-full flex flex-col items-center bg-bg rounded-[0.75rem]">
        <div className="w-full flex flex-col px-4 py-3 items-start gap-0.5">
          <div className="flex items-center gap-1">
            <p className="text-[1.25rem] leading-[1.5625rem] text-text font-semibold">
              {formatNumber(depositAmount, {
                precision: depositAmount < 100 ? constants.TOKEN_DECIMALS : 2,
              })}
            </p>
            <p className="text-[1.0625rem] leading-[1.375rem] text-hint mr-1.5">
              BTN
            </p>
            <Badge active={status === "Active" || status === "Created"}>
              {t(`mydeposits-page.status.${status}`)}
            </Badge>

            <Badge active>{deposit.deposit.network}</Badge>
          </div>
          <p className="text-[0.9375rem] leading-[1.25rem] text-hint">
            {t(`mydeposits-page.day`)}&nbsp;{day}/{days}
          </p>
        </div>
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint">
            {t("mydeposits-page.deposit.total")}:
          </p>
          <p className="text-[1.0625rem] leading-[1.375rem] text-text text-right">
            {formatNumber(totalRewards)}&nbsp;BTN
          </p>
        </div>
        <div className="w-full pl-18">
          <div className="w-full h-px bg-divider"></div>
        </div>
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint">
            Withdrawn:
          </p>
          <p className="text-[1.0625rem] leading-[1.375rem] text-text text-right">
            {formatNumber(withdrawn)}&nbsp;BTN
          </p>
        </div>
        <div className="w-full pl-18">
          <div className="w-full h-px bg-divider"></div>
        </div>
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint">
            {t("mydeposits-page.deposit.daily")}:
          </p>
          <p className="text-[1.0625rem] leading-[1.375rem] text-text text-right">
            {formatNumber(dailyRate)}%
          </p>
        </div>
        <div className="w-full pl-18">
          <div className="w-full h-px bg-divider"></div>
        </div>
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint">
            {t("mydeposits-page.deposit.daily_rewards")}:
          </p>
          <p className="text-[1.0625rem] leading-[1.375rem] text-text text-right">
            {formatNumber((depositAmount * dailyRate) / 100, {
              precision: constants.TOKEN_DECIMALS,
            })}
            &nbsp;BTN
          </p>
        </div>
        <div className="w-full pl-18">
          <div className="w-full h-px bg-divider"></div>
        </div>
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint">
            {t("mydeposits-page.deposit.start")}:
          </p>
          <p className="text-[1.0625rem] leading-[1.375rem] text-text text-right">
            {formatDateLocalized(startDate, i18n.language)}
          </p>
        </div>
        <div className="w-full pl-18">
          <div className="w-full h-px bg-divider"></div>
        </div>
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint">
            {t("mydeposits-page.deposit.end")}:
          </p>
          <p className="text-[1.0625rem] leading-[1.375rem] text-text text-right">
            {formatDateLocalized(endDate, i18n.language)}
          </p>
        </div>
        <div className="w-full pl-18">
          <div className="w-full h-px bg-divider"></div>
        </div>
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint">
            {t("mydeposits-page.deposit.amount")}:
          </p>
          <p className="text-[1.0625rem] leading-[1.375rem] text-text text-right">
            {formatNumber(usdAmount)}
          </p>
        </div>
        <div className="w-full pl-18">
          <div className="w-full h-px bg-divider"></div>
        </div>
        <div className="flex w-full items-center justify-between gap-4 px-4 py-3">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint">
            {t("mydeposits-page.deposit.rate")}:
          </p>
          <p className="text-[1.0625rem] leading-[1.375rem] text-text text-right">
            {formatNumber(deposit.deposit.tokenUsdPrice)} USD
          </p>
        </div>
      </div>
    </>
  );
};

export default Transaction;
